import { defineMessages } from 'react-intl';

export default defineMessages({     
    selectDelMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Please select a batch to delete',
        defaultMessage: 'Please select a batch to delete'
    },
    close: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Close',
        defaultMessage: 'Close'
    },
    deleteNewBatchMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Are you sure you want to delete the request(s)?',
        defaultMessage: 'Are you sure you want to delete the request(s)?'
    },
    batchesTitle: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Batches',
        defaultMessage: 'Batches'
    },
    yes: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'ent.capability.policyportfolio.react.batches-landing.No',
        defaultMessage: 'No'
    },
    ok: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Ok',
        defaultMessage: 'Ok'
    },
    deleteSuccessMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Batches deleted with success',
        defaultMessage: 'Batches deleted with success'
    },
    deleteFailed: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Batches delete failed',
        defaultMessage: 'Batches delete failed'
    },
    sorryMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Sorry, we were not able to delete checked batches',
        defaultMessage: 'Sorry, we were not able to delete checked batches'
    },
    bbtRequest: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Book Of Business Transfer Requests',
        defaultMessage: 'Book Of Business Transfer Requests'
    },
    sureDeleteReq: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Are you sure you want to delete the request(s)',
        defaultMessage: 'Are you sure you want to delete the request(s)?'
    },
    requestId: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Request Id',
        defaultMessage: 'Request ID',
    },
    status: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Status',
        defaultMessage: 'Status',
    },
    processDate: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Process Date',
        defaultMessage: 'Process Date',
    },
    effectiveDate: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Effective Date',
        defaultMessage: 'Effective Date',
    },
    newBatchProcessDateWarning: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Process date cannot be in the past.',
        defaultMessage: 'Process date cannot be in the past.',
    },
    newBatchEffectiveDateWarning: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Effective date of batch can be no earlier than the first day of the current year',
        defaultMessage: 'Effective date of batch can be no earlier than the first day of the current year.',
    },
    newAndOldSameCode: {
        id: 'ent.capability.policyportfolio.react.batches-landing.New producer code cannot be the same as the old producer code',
        defaultMessage: 'New producer code cannot be the same as the old producer code.',
    },
    noMatchOldProCode: {
        id: 'ent.capability.policyportfolio.react.batches-landing.No policies matched the selected old producer code',
        defaultMessage: 'No policies matched the selected old producer code.',
    },
    newBatchCancelHeading: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Cancel Batch Request',
        defaultMessage: 'Cancel Transfer Request Creation',
    },
    newBatchCancelMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Are you sure you want to cancel the request?',
        defaultMessage: 'Are you sure you want to cancel the request?',
    },
    newBatchRequest: {
        id: 'ent.capability.policyportfolio.react.batches-landing.New Transfer Request',
        defaultMessage: 'New Transfer Request',
    },
    transferRequestDetail: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Transfer Request Details',
        defaultMessage: 'Transfer Request Details',
    },
    transferRequestMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Transfer Request is Pending Approval',
        defaultMessage: 'Transfer Request is Pending Approval.',
    },
    newBatchCreationHeading: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Create Batch',
        defaultMessage: 'Create Batch',
    },
    newBatchCreationMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Successed',
        defaultMessage: 'Successed',
    },
    sorryMsgAdd: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Sorry, we were not able to add a new batch',
        defaultMessage: 'Sorry, we were not able to add a new batch'
    },
    createReqMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Are you sure you want to create the request?',
        defaultMessage: 'Are you sure you want to create the request?'
    },
    transferReqSuccessMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Transfer Request(s) saved.',
        defaultMessage: 'Transfer Request(s) saved.'
    },
    transferReqDelMsg: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Transfer request(s) deleted.',
        defaultMessage: 'Transfer request(s) deleted.'
    },
    errorReport: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Error generating report.',
        defaultMessage: 'Error generating report.'
    },
    dateMustmatch: {
        id: 'ent.capability.policyportfolio.react.batches-landing.Please enter a valid date (MM/DD/YYYY).',
        defaultMessage : 'Please enter a valid date (MM/DD/YYYY).'
    }
})